export function Badge({ children, tone = "accent", className = "" }) {
  return (
    <span className={`badge badge-${tone} ${className}`.trim()}>
      <span className="badge-dot"></span>
      <span>{children}</span>
    </span>
  );
}
